import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown, DropdownButton } from 'react-bootstrap'
import Select from 'react-select'

import DeleteModal from 'pages/parts/DeleteModal'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import PeriodPicker from 'pages/parts/PeriodPicker'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'
import LoyaltyHistory from './LoyaltyHistory'

import { httpOk, POST, PUT, PATCH, GET, FILE_D, FILE, DELETE } from 'helpers/api'
import { formatDate, regexPhoneNumber, returnSign, findKeyFromArrayByValue, formatMoney } from 'helpers/helpers'
import HintIcon from 'pages/parts/HintIcon'
import SmsCounter from 'pages/parts/SmsCounter'
import SmsCatalogPicker from 'pages/parts/SmsCatalogPicker'
import { hasPermission } from 'helpers/permissions'

// Каналы заказов в фильтре — массив; в URL и в SMS по фильтру уходят через запятую
function channelList(value) {
	if (!value) return []
	return Array.isArray(value) ? value : String(value).split(',').filter(Boolean)
}

function Index() {
	const { t } = useTranslation()

	const statuses = [
		{ "id": 1, "name": t('success') },
		{ "id": -1, "name": t('deleted') },
	]

	// Варианты фильтров совпадают с ClientFilterService на бэкенде. Какие поля показывать
	// (каналы бренда, есть ли бот и лояльность) — из /clients/filter-options
	const orderChannels = [
		{ id: 'cashbox_delivery', name: t('channel_cashbox_delivery') },
		{ id: 'call_center', name: t('channel_call_center') },
		{ id: 'telegram', name: t('channel_telegram') },
		{ id: 'website', name: t('channel_website') },
		{ id: 'mobile_app', name: t('channel_mobile_app') },
	]
	const channelModes = [
		{ id: 'ordered', name: t('channel_mode_ordered') },
		{ id: 'not_ordered', name: t('channel_mode_not_ordered') },
	]
	const loyaltyStates = [
		{ id: 'balance', name: t('loyalty_state_balance') },
		{ id: 'spent', name: t('loyalty_state_spent') },
		{ id: 'never', name: t('loyalty_state_never') },
	]
	const telegramStates = [
		{ id: 'subscribed', name: t('telegram_state_subscribed') },
		{ id: 'not_subscribed', name: t('telegram_state_not_subscribed') },
		{ id: 'blocked', name: t('telegram_state_blocked') },
	]

	// ДР в ближайшие N дней (сегодня включительно) — тот же отбор, что в виджете дашборда
	const birthdayPeriods = [
		{ id: 0, name: t('birthday_today') },
		{ id: 7, name: t('birthday_week') },
		{ id: 30, name: t('birthday_month') },
	]

	// Переход из виджета «Дни рождения»: /clients?birthday_days=7 — сразу отбор и сортировка по дате
	const initialBirthdayDays = (() => {
		const value = new URLSearchParams(window.location.search).get('birthday_days')
		return value !== null && value !== '' && !isNaN(Number(value)) ? Number(value) : null
	})()

	const [data, setData] = useState([])
	const [poses, setPoses] = useState([])
	const [filterOptions, setFilterOptions] = useState({ channels: [], has_telegram_bot: false, has_loyalty: false })
	const [discounts, setDiscounts] = useState([])
	const [smsTemplates, setSmsTemplates] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	// ДР на момент открытия карточки: указанный гостем меняет только сотрудник с правом
	const [initialBirthday, setInitialBirthday] = useState(null)
	const isBirthdayLocked = !!selectedItem.id && !!initialBirthday && !hasPermission('client_birthday_edit')
	const [modalManualLoyaltyPoints, setModalManualLoyaltyPoints] = useState(false)
	const [modalWriteOffLoyaltyPoints, setModalWriteOffLoyaltyPoints] = useState(false)
	const [showModal, setShowModal] = useState(false)
	const [loyaltyHistory, setLoyaltyHistory] = useState({ show: false, client: {} })
	const [showCardModal, setCardShowModal] = useState(false)
	const [modalSMS, setModalSMS] = useState({
		bool: false,
		message: '',
		sms_template_id: null,
		client_id: null,
		client_name: null,
	})
	// Mison SMS: шаблон из каталога вместо своего текста (SmsCatalogPicker)
	const [isSmsCatalog, setIsSmsCatalog] = useState(false)
	const [smsCatalog, setSmsCatalog] = useState({ template_code: null, vars: {}, locale: 'auto' })
	const [modalChangePhone, setModalChangePhone] = useState(false)
	const [modalDeleteClient, setModalDeleteClient] = useState(false)
	const [modalRestoreClient, setModalRestoreClient] = useState(false)
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const {
		filterData,
		appliedFilterData,
		setAppliedFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		patchFilterData,
		applySearch,
		applyFilters,
		paginate,
		resetToInitialFilters,
	} = useFilterSearchPagination({
		initialFilterData: {
			status: 1,
			search: '',
			birthday_days: initialBirthdayDays,
			// Совпадает с порядком бэкенда по умолчанию — стрелка сразу показывает, как отсортировано.
			// С отбором по ДР — ближайшие именинники сверху
			sort_key: initialBirthdayDays !== null ? 'next_birthday' : 'count_cheques',
			sort_dir: initialBirthdayDays !== null ? 'asc' : 'desc',
		},
		initialPagination: {
			url: '/clients',
			response: null,
		},
	})

	async function searchWithFilter(passedData = {}) {
		var filterDataCopy = { ...filterData, ...(passedData.filterData || {}) }
		var filterUrl = "/clients"
		var urlParams = ""
		checkFilter(filterDataCopy)

		if (filterDataCopy.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (filterDataCopy.status)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.loyalty)
			urlParams += returnSign(urlParams) + 'loyalty=' + filterDataCopy.loyalty
		if (filterDataCopy.telegram)
			urlParams += returnSign(urlParams) + 'telegram=' + filterDataCopy.telegram
		if (channelList(filterDataCopy.channels).length > 0) {
			urlParams += returnSign(urlParams) + 'channels=' + channelList(filterDataCopy.channels).join(',')
			urlParams += returnSign(urlParams) + 'channel_mode=' + (filterDataCopy.channel_mode || 'ordered')
		}
		if (filterDataCopy.registration_date_start)
			urlParams += returnSign(urlParams) + 'registration_date_start=' + filterDataCopy.registration_date_start
		if (filterDataCopy.registration_date_end)
			urlParams += returnSign(urlParams) + 'registration_date_end=' + filterDataCopy.registration_date_end
		if (filterDataCopy.last_cheque_start)
			urlParams += returnSign(urlParams) + 'last_cheque_start=' + filterDataCopy.last_cheque_start
		if (filterDataCopy.last_cheque_end)
			urlParams += returnSign(urlParams) + 'last_cheque_end=' + filterDataCopy.last_cheque_end
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.birthday_days !== null && filterDataCopy.birthday_days !== undefined)
			urlParams += returnSign(urlParams) + 'birthday_days=' + filterDataCopy.birthday_days
		if (filterDataCopy.count_cheques_from !== '' && filterDataCopy.count_cheques_from !== null && filterDataCopy.count_cheques_from !== undefined)
			urlParams += returnSign(urlParams) + 'count_cheques_from=' + filterDataCopy.count_cheques_from
		if (filterDataCopy.count_cheques_to !== '' && filterDataCopy.count_cheques_to !== null && filterDataCopy.count_cheques_to !== undefined)
			urlParams += returnSign(urlParams) + 'count_cheques_to=' + filterDataCopy.count_cheques_to
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page
		filterDataCopy.urlParams = urlParams

		if (`/clients${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		// Сортировка не фильтр: в urlParams (выгрузки, плашка фильтра) не попадает
		if (filterDataCopy.sort_key)
			urlParams += returnSign(urlParams) + 'sort=' + filterDataCopy.sort_key + ',' + filterDataCopy.sort_dir

		filterUrl = filterUrl + urlParams


		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setAppliedFilterData(filterDataCopy)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}
		setDropdownIsOpen(false)
	}

	async function createUpdate(e) {
		e.preventDefault();

		var response;
		if (selectedItem.id) {
			response = await PUT('/clients', selectedItem, { loader: true })
		} else {
			response = await POST('/clients', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalCreateUpdate()
		}
	}

	async function manualLoyaltyPoints(e) {
		e.preventDefault();

		var response = await POST('/clients/manual-loyalty-points', selectedItem, { loader: true })

		if (httpOk(response)) {
			searchWithFilter()
			setModalManualLoyaltyPoints()
		}
	}

	async function manualWriteOff(e) {
		e.preventDefault();

		var response = await POST('/clients/write-off-loyalty-points', selectedItem, { loader: true })

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalWriteOffLoyaltyPoints()
		}
	}

	async function changePhone(e) {
		e.preventDefault();

		var response = await PATCH(`/clients/${selectedItem.id}/phone`,
			{ 'phone1': selectedItem.new_phone }, { loader: true })

		if (httpOk(response)) {
			searchWithFilter()
			toggleModalChangePhone()
		}
	}

	async function sendSms(e) {
		e.preventDefault();
		var filterDataCopy = { ...filterData }
		if (isSmsCatalog) {
			filterDataCopy.template_code = smsCatalog.template_code
			filterDataCopy.vars = smsCatalog.vars
			filterDataCopy.locale = smsCatalog.locale
		} else {
			filterDataCopy.message = modalSMS.message
			filterDataCopy.sms_template_id = modalSMS.sms_template_id
		}
		if (modalSMS.client_id) {
			filterDataCopy.client_id = modalSMS.client_id
		}

		var response = await POST('/sms/send-clients', filterDataCopy, { loader: true })

		if (httpOk(response)) {
			closeModalSMS()
		}
	}

	async function bindCard(e) {
		e.preventDefault();

		var response = await POST('/clients-cards', selectedItem, { loader: true })

		if (httpOk(response)) {
			setCardShowModal(false)
			searchWithFilter()
		}
	}

	function toggleModalCreateUpdate(bool = false, item = { 'gender': 1 }) {
		setSelectedItem(item)
		setInitialBirthday(item.birthday ?? null)
		setShowModal(bool)
	}

	function toggleModalCard(bool = false, item = {}) {
		if (bool) getDiscounts()

		setSelectedItem(item)
		setCardShowModal(bool)
	}

	function toggleModalManualLoyaltyPoints(bool = false, item = {}) {
		setSelectedItem(item)
		setModalManualLoyaltyPoints(bool)
	}

	function toggleModalWriteOffLoyaltyPoints(bool = false, item = {}) {
		setSelectedItem(item)
		setModalWriteOffLoyaltyPoints(bool)
	}

	// new_phone держим отдельно от phone1: phone1 в selectedItem — текущий номер,
	// его показываем рядом, чтобы было видно, с чего на что меняем.
	function toggleModalChangePhone(bool = false, item = {}) {
		setSelectedItem({ ...item, 'new_phone': '' })
		setModalChangePhone(bool)
	}

	function toggleDeleteModal(item) {
		setSelectedItem(item)
		setModalDeleteClient(true)
	}

	function closeModalSMS() {
		setSmsCatalog({ template_code: null, vars: {}, locale: 'auto' })
		setModalSMS({
			bool: false,
			message: '',
			sms_template_id: null,
			client_id: null,
			client_name: null,
		})
	}

	async function toggleModalSMS(bool) {
		if (bool) {
			var response = await GET('/helper/sms-templates?sms_type_id=1')
			if (httpOk(response)) setSmsTemplates(response.data)
		}
		if (!bool) {
			closeModalSMS()
			return
		}
		setModalSMS({
			bool: true,
			message: '',
			sms_template_id: null,
			client_id: null,
			client_name: null,
		})
	}

	async function openClientSms(item) {
		const response = await GET('/helper/sms-templates?sms_type_id=1')
		if (httpOk(response)) setSmsTemplates(response.data)
		setModalSMS({
			bool: true,
			message: '',
			sms_template_id: null,
			client_id: item.id,
			client_name: item.first_name || regexPhoneNumber(item.phone1),
		})
	}

	async function deleteClient(e) {
		e.preventDefault();

		var sendData = { ...selectedItem }
		sendData.status = -1
		var response = await PUT('/clients-status', sendData, { loader: true })

		if (httpOk(response)) {
			searchWithFilter()
			toggleDeleteModal()
		}
	}

	async function restoreClient(e) {
		e.preventDefault();

		const response = await PATCH(`/clients/${selectedItem.id}/restore`, {}, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			toggleRestoreModal()
		}
	}

	function resetFilter() {
		resetToInitialFilters((nextFilterData) => {
			searchWithFilter({ filterData: nextFilterData })
		})
	}

	function checkFilter(currentFilterData) {
		if (
			currentFilterData.pos_id === null &&
			currentFilterData.start_date === null &&
			currentFilterData.end_date === null &&
			currentFilterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function toggleRestoreModal(bool = false, item = {}) {
		setSelectedItem(item)
		setModalRestoreClient(bool)
	}

	async function deleteItem() {
		const response = await DELETE(`/clients/${deleteModalParams.id}`, {}, { loader: true })
		if (httpOk(response)) {
			searchWithFilter()
			setModalDelete(false)
		}
	}

	function handleInputChange(e) {
		var selectedItemCopy = { ...selectedItem }
		selectedItemCopy[e.target.name] = e.target.value
		setSelectedItem(selectedItemCopy)
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	async function getFilterOptions() {
		const response = await GET('/clients/filter-options')
		if (httpOk(response)) setFilterOptions(response.data)
	}

	async function downloadExcelFile() {
		var response = await FILE_D('/clients-excel')
		if (httpOk(response)) {
			// Создаем объект Blob из полученного файла
			const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

			// Создаем ссылку для скачивания файла
			const fileUrl = URL.createObjectURL(file);

			// Создаем ссылку для скачивания файла в браузере
			const link = document.createElement('a');
			link.href = fileUrl;
			link.setAttribute('download', `${t('clients')}.xlsx`);
			document.body.appendChild(link);
			link.click();

			// Удаляем ссылку после скачивания файла
			URL.revokeObjectURL(fileUrl);
		}
	}

	async function EExcelClientAddress() {
		var response = await FILE_D('/clients-address-excel')
		if (httpOk(response)) {
			// Создаем объект Blob из полученного файла
			const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

			// Создаем ссылку для скачивания файла
			const fileUrl = URL.createObjectURL(file);

			// Создаем ссылку для скачивания файла в браузере
			const link = document.createElement('a');
			link.href = fileUrl;
			link.setAttribute('download', `${t('address')}.xlsx`);
			document.body.appendChild(link);
			link.click();

			// Удаляем ссылку после скачивания файла
			URL.revokeObjectURL(fileUrl);
		}
	}

	async function importFromExel(e) {
		let formData = new FormData();
		formData.append("file", e.target.files[0]);

		var response = await FILE('/clients-excel-import', formData, {}, { loader: true });

		if (httpOk(response)) searchWithFilter()
	}

	async function getDiscounts() {
		if (!discounts.length) {
			const response = await GET('/clients-cards-discounts')
			if (httpOk(response)) {
				setDiscounts(response.data)
			}
		}
	}

	// Первый клик — по убыванию (больше чеков, свежее дата), повторный переворачивает
	function sortBy(key) {
		const sort_dir = filterData.sort_key === key && filterData.sort_dir === 'desc' ? 'asc' : 'desc'
		const nextFilterData = { ...filterData, sort_key: key, sort_dir, page: null }
		patchFilterData({ sort_key: key, sort_dir, page: null })
		searchWithFilter({ filterData: nextFilterData })
	}

	function renderSortTh(key, title, className, style) {
		const active = filterData.sort_key === key
		return (
			<th style={style} className={`th-sortable ${className}`} title={title} onClick={() => sortBy(key)}>
				{/* max-width: 0 из td-ellipsis рассчитан на саму ячейку; на div внутри th он оставлял
				видимым только отступ, и подпись читалась как «Де» */}
				<div className="td-ellipsis" style={{ 'paddingRight': '14px', 'maxWidth': 'none' }}>{title}</div>
				<div className="table-sort">
					<i className={`uil ${active && filterData.sort_dir === 'asc' ? 'uil-angle-up' : 'uil-angle-down'} ${active ? 'sort-active' : ''}`}></i>
				</div>
			</th>
		)
	}

	useEffect(() => {
		getPoses()
		getFilterOptions()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('clients')} [{formatMoney(data?.total)}]
				</h4>
				<DropdownButton title={t('action')}>
					<Dropdown.Item onClick={() => toggleModalCreateUpdate(true)}>
						{t('create')}
					</Dropdown.Item>
					<Dropdown.Item onClick={() => toggleModalSMS(true)}>
						{t('sms_sending')}
					</Dropdown.Item>
					<Dropdown.Item as="li" eventKey="1">
						<input id="actual-btn" hidden type="file" onChange={importFromExel} accept=".xlsx, application/vnd.ms-excel" />
						<label htmlFor="actual-btn" className="upload-from-excel">{t('import_clients')}</label>
					</Dropdown.Item>
					<Dropdown.Item as="li" eventKey="2">
						<a href={`${process.env.REACT_APP_DOWNLOAD_DOMAIN}/files/clients_template.xlsx`} className="upload-from-excel">
							{t('download_template')}
						</a>
					</Dropdown.Item>
					<Dropdown.Item onClick={() => downloadExcelFile()}>
						{t('export_clients')}
					</Dropdown.Item>
					<Dropdown.Item onClick={() => EExcelClientAddress()}>
						{t('export_clients_addresses')}
					</Dropdown.Item>
				</DropdownButton>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={(search) => applySearch(search, (nextFilterData) => {
										searchWithFilter({ filterData: nextFilterData })
									})}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => patchFilterData({ 'pos_id': option.id })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={statuses}
													value={statuses.find(option => option.id === filterData.status) || ''}
													onChange={(option) => patchFilterData({ 'status': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('birthday')}</label>
												<Select
													isClearable
													options={birthdayPeriods}
													value={birthdayPeriods.find(option => option.id === filterData.birthday_days) || ''}
													onChange={(option) => patchFilterData({ 'birthday_days': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											{/* Число чеков: 1 — новые гости, 10+ — постоянные. Те же условия уходят и в SMS по фильтру */}
											<div className="form-group col-md-6">
												<label>{t('cheques_count_range')}</label>
												<div className="d-flex gap-2">
													<input type="text" className="form-control" inputMode="numeric"
														placeholder={t('from')}
														value={filterData.count_cheques_from ?? ''}
														onChange={(e) => patchFilterData({ 'count_cheques_from': e.target.value.replace(/[^0-9]/g, '') })} />
													<input type="text" className="form-control" inputMode="numeric"
														placeholder={t('to')}
														value={filterData.count_cheques_to ?? ''}
														onChange={(e) => patchFilterData({ 'count_cheques_to': e.target.value.replace(/[^0-9]/g, '') })} />
												</div>
											</div>
										</div>
										{/* Регистрация и последний чек — рядом: оба периода, читаются парой */}
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('registered')}</label>
												<PeriodPicker
													withTime={false}
													startDate={filterData.registration_date_start}
													endDate={filterData.registration_date_end}
													minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
													maxDate={new Date(new Date().getFullYear(), 11, 31)}
													clearable
													onChange={(period) => patchFilterData({ 'registration_date_start': period.start_date, 'registration_date_end': period.end_date })}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('last_cheque')}</label>
												<PeriodPicker
													withTime={false}
													startDate={filterData.last_cheque_start}
													endDate={filterData.last_cheque_end}
													minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
													maxDate={new Date(new Date().getFullYear(), 11, 31)}
													clearable
													onChange={(period) => patchFilterData({ 'last_cheque_start': period.start_date, 'last_cheque_end': period.end_date })}
												/>
											</div>
										</div>
										{/* Каналы заказов — только те, через которые у гостей бренда были заказы
										(Яндекс и Uzum к гостю не привязаны, поэтому их здесь нет) */}
										{filterOptions.channels?.length > 0 &&
											<div className="row">
												<div className="form-group col-md-6">
													<label>{t('order_channels')}</label>
													<Select
														options={channelModes}
														value={channelModes.find(option => option.id === (filterData.channel_mode || 'ordered'))}
														onChange={(option) => patchFilterData({ 'channel_mode': option.id })}
														isSearchable={false}
														placeholder=""
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
													/>
												</div>
												<div className="form-group col-md-6">
													<label>&nbsp;</label>
													<Select
														isMulti
														options={orderChannels.filter(option => filterOptions.channels.includes(option.id))}
														value={orderChannels.filter(option => channelList(filterData.channels).includes(option.id))}
														onChange={(options) => patchFilterData({ 'channels': options?.length ? options.map(option => option.id) : null })}
														placeholder={t('order_channels_any')}
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
													/>
												</div>
											</div>
										}
										{/* Баллы и Telegram-бот — только у брендов, где они вообще есть */}
										{(filterOptions.has_loyalty || filterOptions.has_telegram_bot) &&
											<div className="row">
												{filterOptions.has_loyalty &&
													<div className="form-group col-md-6">
														<label>{t('loyalty_points')}</label>
														<Select
															isClearable
															options={loyaltyStates}
															value={loyaltyStates.find(option => option.id === filterData.loyalty) || ''}
															onChange={(option) => patchFilterData({ 'loyalty': option ? option.id : null })}
															isSearchable={false}
															placeholder=""
															getOptionLabel={(option) => option.name}
															getOptionValue={(option) => option.id}
														/>
													</div>
												}
												{filterOptions.has_telegram_bot &&
													<div className="form-group col-md-6">
														<label>{t('telegram_bot')}</label>
														<Select
															isClearable
															options={telegramStates}
															value={telegramStates.find(option => option.id === filterData.telegram) || ''}
															onChange={(option) => patchFilterData({ 'telegram': option ? option.id : null })}
															isSearchable={false}
															placeholder=""
															getOptionLabel={(option) => option.name}
															getOptionValue={(option) => option.id}
														/>
													</div>
												}
											</div>
										}
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary"
														onClick={() => applyFilters((nextFilterData) => {
															searchWithFilter({ filterData: nextFilterData })
														})}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							{/* Telegram и лояльность есть не у всех заведений — счётчики по ним под кнопкой,
							а не постоянно в шапке. Считаются по текущему фильтру */}
							{(filterOptions.has_telegram_bot || filterOptions.has_loyalty) &&
								<div>
									<Dropdown align="end">
										<Dropdown.Toggle variant="outline-primary" className="h-100">
											<i className="uil uil-chart-pie me-1"></i>
											{t('statistics')}
										</Dropdown.Toggle>
										<Dropdown.Menu className="p-3" style={{ 'minWidth': '280px' }}>
											{filterOptions.has_telegram_bot &&
												<div className="mb-3">
													<b>{t('telegram')}</b>
													<div className="d-flex justify-content-between mt-1">
														<span className="text-muted">{t('stats_tg_member')}</span>
														<span className="text-success">{formatMoney(data.total_member)}</span>
													</div>
													<div className="d-flex justify-content-between">
														<span className="text-muted">{t('stats_tg_kicked')}</span>
														<span className="text-danger">{formatMoney(data.total_kicked)}</span>
													</div>
												</div>
											}
											{filterOptions.has_loyalty &&
												<div>
													<b>{t('loyalty')}</b>
													<div className="d-flex justify-content-between mt-1">
														<span className="text-muted">{t('stats_loyalty_yes')}</span>
														<span className="text-success">{formatMoney(data.total_loyalty_yes)}</span>
													</div>
													<div className="d-flex justify-content-between">
														<span className="text-muted">{t('stats_loyalty_no')}</span>
														<span className="text-danger">{formatMoney(data.total_loyalty_no)}</span>
													</div>
												</div>
											}
										</Dropdown.Menu>
									</Dropdown>
								</div>
							}
						</div>

					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(appliedFilterData.registration_date_start || appliedFilterData.registration_date_end) &&
									<span className="me-2">
										<b>{t('registered')}: </b>
										{appliedFilterData.registration_date_start &&
											<span>{formatDate(appliedFilterData.registration_date_start)}</span>
										}
										{(appliedFilterData.registration_date_start && appliedFilterData.registration_date_end) &&
											<span>|</span>
										}
										{appliedFilterData.registration_date_end &&
											<span>{formatDate(appliedFilterData.registration_date_end)}</span>
										}
									</span>
								}
								{(appliedFilterData.last_cheque_start || appliedFilterData.last_cheque_end) &&
									<span className="me-2">
										<b>{t('last_cheque')}: </b>
										{appliedFilterData.last_cheque_start &&
											<span>{formatDate(appliedFilterData.last_cheque_start)}</span>
										}
										{(appliedFilterData.last_cheque_start && appliedFilterData.last_cheque_end) &&
											<span>|</span>
										}
										{appliedFilterData.last_cheque_end &&
											<span>{formatDate(appliedFilterData.last_cheque_end)}</span>
										}
									</span>
								}
								{appliedFilterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', appliedFilterData.pos_id, 'name')}
									</span>
								}
								{channelList(appliedFilterData.channels).length > 0 &&
									<span className="me-2">
										<b>{findKeyFromArrayByValue(channelModes, 'id', appliedFilterData.channel_mode || 'ordered', 'name')}: </b>
										{channelList(appliedFilterData.channels).map(id => findKeyFromArrayByValue(orderChannels, 'id', id, 'name')).join(', ')}
									</span>
								}
								{appliedFilterData.loyalty &&
									<span className="me-2">
										<b>{t('loyalty_points')}: </b>
										{findKeyFromArrayByValue(loyaltyStates, 'id', appliedFilterData.loyalty, 'name')}
									</span>
								}
								{appliedFilterData.telegram &&
									<span className="me-2">
										<b>{t('telegram_bot')}: </b>
										{findKeyFromArrayByValue(telegramStates, 'id', appliedFilterData.telegram, 'name')}
									</span>
								}
								{(appliedFilterData.birthday_days !== null && appliedFilterData.birthday_days !== undefined) &&
									<span className="me-2">
										<b>{t('birthday')}: </b>
										{findKeyFromArrayByValue(birthdayPeriods, 'id', appliedFilterData.birthday_days, 'name')}
									</span>
								}
								{(appliedFilterData.count_cheques_from || appliedFilterData.count_cheques_to) &&
									<span className="me-2">
										<b>{t('cheques_count_range')}: </b>
										{appliedFilterData.count_cheques_from && `${t('from')} ${appliedFilterData.count_cheques_from} `}
										{appliedFilterData.count_cheques_to && `${t('to')} ${appliedFilterData.count_cheques_to}`}
									</span>
								}
								{appliedFilterData.status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{findKeyFromArrayByValue(statuses, 'id', appliedFilterData.status, 'name')}
									</span>
								}
								{appliedFilterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{appliedFilterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'minWidth': '140px' }}>{t('phone')}</th>
									{/* Примечание (есть у 0,5% клиентов), номер карты и «Лояльность суммарно»
									(отличается от баллов у 0,8%) — не колонками, а в ячейках имени и баллов */}
									<th style={{ 'width': '30%' }}>{t('name')}</th>
									{/* Подпись сортируемой колонки обрезается (td-ellipsis), поэтому ширину держит
									minWidth: без строк в таблице проценты не работали и колонки схлопывались до «Де», «Лс» */}
									{renderSortTh('next_birthday', t('birthday'), 'text-center', { 'minWidth': '140px' })}
									{renderSortTh('count_cheques', t('cheques'), 'text-end', { 'width': '10%', 'minWidth': '80px' })}
									{renderSortTh('loyalty_balance', t('loyalty'), 'text-end', { 'width': '10%', 'minWidth': '120px' })}
									{renderSortTh('created_at', t('registered'), 'text-center', { 'width': '10%', 'minWidth': '150px' })}
									{renderSortTh('last_cheque_date', t('last_cheque'), 'text-center', { 'width': '10%', 'minWidth': '140px' })}
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center" title={item.id}>{item.row_number}</td>
										<td>{regexPhoneNumber(item.phone1)}</td>
										<td>
											<div className="d-flex align-items-center gap-2">
												<div style={{ 'minWidth': 0, 'flex': '1 1 auto' }}>
													<div>{item.first_name}</div>
													{item.card_numbers &&
														<div className="text-muted" title={item.card_numbers} style={{ 'fontSize': '12px', 'whiteSpace': 'nowrap', 'overflow': 'hidden', 'textOverflow': 'ellipsis' }}>
															<i className="uil uil-credit-card me-1"></i>{item.card_numbers}
														</div>
													}
												</div>
												{item.note &&
													<i className="uil uil-comment-alt-notes text-warning" title={item.note}
														style={{ 'fontSize': '18px', 'lineHeight': '1', 'cursor': 'help' }}></i>
												}
												<i className={`uil uil-telegram ${item.telegram_user_id ? 'text-primary' : 'text-danger'}`}
													style={{ 'fontSize': '20px', 'lineHeight': '1' }}>
												</i>
											</div>
										</td>
										<td className="text-center">{formatDate(item.birthday)}</td>
										<td className="text-end">{item.count_cheques}</td>
										{/* Накоплено всего отличается от баллов на счету только у тех, кто тратил баллы */}
										<td className="text-end"
											title={`${t('loyalty_overall')}: ${formatMoney(item.loyalty_balance_up)}`}
											style={{ 'cursor': 'help' }}>
											{formatMoney(item.loyalty_balance)}
										</td>
										<td className="text-center">{formatDate(item.created_at)}</td>
										<td className="text-center">{formatDate(item.last_cheque_date)}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModalCreateUpdate(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														<div className="table-dropdown-item"
															onClick={() => toggleModalChangePhone(true, item)}>
															<i className="uil-mobile-android"></i>
															{t('change_phone')}
														</div>
														<div className="table-dropdown-item"
															onClick={() => toggleModalCard(true, item)}>
															<i className="uil-user-plus"></i>
															{t('link_card')}
														</div>
														<div className="table-dropdown-item"
															onClick={() => toggleModalManualLoyaltyPoints(true, item)}>
															<i className="uil-trophy"></i>
															<span style={{ 'lineHeight': '14px' }}>{t('assign_loyalty_points')}</span>
														</div>
														<div className="table-dropdown-item"
															onClick={() => toggleModalWriteOffLoyaltyPoints(true, item)}>
															<i className="uil-trophy"></i>
															<span style={{ 'lineHeight': '14px' }}>{t('manual_deduction')}</span>
														</div>
														<div className="table-dropdown-item"
															onClick={() => setLoyaltyHistory({ show: true, client: item })}>
															<i className="uil-history"></i>
															<span style={{ 'lineHeight': '14px' }}>{t('loyalty_history')}</span>
														</div>
														<div className="table-dropdown-item"
															onClick={() => openClientSms(item)}>
															<i className="uil-comment-alt-message"></i>
															{t('sms_sending')}
														</div>
														{item.status === 1 &&
															<div className="table-dropdown-item text-danger"
																onClick={() => {
																	setDeleteModalParams({ id: item.id, index: index });
																	setModalDelete(true)
																}}>
																<i className="uil-times"></i>
																{t('delete')}
															</div>
														}
														{item.status === -1 &&
															<div className="table-dropdown-item text-success"
																onClick={() => toggleRestoreModal(true, item)}>
																<i className="uil-history-alt"></i>
																{t('restore')}
															</div>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={(page) => {
								paginate(page)
								searchWithFilter({ filterData: { ...filterData, page } })
							}}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL CREATE UPDATE */}
			<Modal show={showModal} animation={false} centered
				dialogClassName="update-modal-width" onHide={() => toggleModalCreateUpdate()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{selectedItem.id ?
							<>{t('edit')}</>
							:
							<>{t('create')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('name')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="first_name"
								value={selectedItem.first_name ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('phone')}{!!selectedItem.id && <HintIcon text={t('phone_change_hint')} />}</label>
							{/* При редактировании поле заблокировано: updateService не обновляет phone1,
								и раньше правка здесь молча пропадала. Номер меняется отдельным пунктом. */}
							<input type="number" className="form-control" name="phone1"
								disabled={!!selectedItem.id}
								value={selectedItem.phone1 ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						<div className="form-group">
							<label>{t('additional_phone')}</label>
							<input type="number" className="form-control" name="phone2"
								value={selectedItem.phone2 ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						<div className="form-group">
							<label>
								{t('birthday')}
								{isBirthdayLocked && <HintIcon text={t('birthday_locked_hint')} />}
							</label>
							{/* Пустой ДР заполняет любой; уже указанный — только с правом «Исправлять
								день рождения» (сервер проверит и запишет правку в журнал) */}
							<input type="date" className="form-control" name="birthday"
								disabled={isBirthdayLocked}
								min="1900-01-01"
								value={selectedItem.birthday ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						<div className="d-flex justify-content-between mb-2">
							<div className="d-flex gap-3">
								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setSelectedItem({ ...selectedItem, 'gender': 1 })}
										style={{ 'backgroundColor': selectedItem.gender === 1 ? 'black' : '' }}>
									</div>
									<span onClick={() => setSelectedItem({ ...selectedItem, 'gender': 1 })}>
										{t('man')}
									</span>
								</div>

								<div className="form-check p-0">
									<div className="radio-round"
										onClick={() => setSelectedItem({ ...selectedItem, 'gender': 2 })}
										style={{ 'backgroundColor': selectedItem.gender === 2 ? 'black' : '' }}>
									</div>
									<span onClick={() => setSelectedItem({ ...selectedItem, 'gender': 2 })}>
										{t('woman')}
									</span>
								</div>
							</div>
						</div>
						<div className="form-group">
							<label>{t('debt_limit')}</label>
							<input type="text" className="form-control" name="debt_limit"
								value={selectedItem.debt_limit ?? ''}
								onChange={(e) => setSelectedItem({
									...selectedItem,
									'debt_limit': e.target.value.replace(/[^0-9.]/g, '')
								})} />
						</div>
						<div className="form-group">
							<label>{t('note')}</label>
							<input type="text" className="form-control" name="note"
								value={selectedItem.note ?? ''}
								onChange={(e) => handleInputChange(e)} />
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalCreateUpdate()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CREATE UPDATE */}

			{/* MODAL SMS */}
			<Modal show={modalSMS.bool} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={closeModalSMS}>
				<Modal.Header closeButton>
					<Modal.Title>
						{modalSMS.client_id
							? `${t('sms_sending')} — ${modalSMS.client_name || ''}`
							: t('sms_sending')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={sendSms} autoComplete="off">
						{modalSMS.bool &&
							<SmsCatalogPicker
								usage="marketing"
								value={smsCatalog}
								onChange={setSmsCatalog}
								onModeChange={setIsSmsCatalog}
								exampleName={modalSMS.client_id ? modalSMS.client_name : null}
							/>
						}

						{!isSmsCatalog &&
							<>
								<div className="form-group">
									<label>{t('sms_templates')}</label>
									<Select
										options={smsTemplates}
										value={smsTemplates.find(option => option.id === modalSMS.sms_template_id) || null}
										onChange={(option) => setModalSMS({
											...modalSMS,
											sms_template_id: option ? option.id : null,
											message: option ? option.text : '',
										})}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>

								<div className="form-group">
									<label>{t("description")}</label>
									<textarea className="form-control" rows="5"
										disabled
										readOnly
										value={modalSMS.message || ''}>
									</textarea>
									<SmsCounter text={modalSMS.message} />
								</div>
							</>
						}

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={closeModalSMS}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL SMS */}

			{/* MODAL CLIENT CARD */}
			<Modal show={showCardModal} animation={false} centered
				size="md"
				onHide={() => toggleModalCard()}>
				<Modal.Header closeButton>
					<Modal.Title>{t('link_card')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => bindCard(e)} autoComplete="off">
						<div className="form-group w-100">
							<label>{t('client')}</label>
							<input type="text" className="form-control" name="first_name"
								disabled
								value={selectedItem.first_name ?? ''}
								onChange={(e) => { }} />
						</div>

						<div className="form-group w-100">
							<label>{t('card_number')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="card_number" autoFocus
								value={selectedItem.card_number ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'card_number': e.target.value.replace(/[^0-9]/g, '') })} />
						</div>

						<div className="form-group w-100">
							<label>{t('discount')}</label>
							<Select
								options={discounts}
								value={discounts.find(option => option.id === selectedItem.discount_service_id) || ''}
								onChange={(option) => setSelectedItem({ ...selectedItem, 'discount_service_id': option.id })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						<div className="d-flex w-100 mt-3 gap-2">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalCard()}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CLIENT CARD */}

			{/* MODAL MANUAL LOYALTY POINTS */}
			<Modal show={modalManualLoyaltyPoints} animation={false} centered
				size="md"
				onHide={() => toggleModalManualLoyaltyPoints()}>
				<Modal.Header closeButton>
					<Modal.Title>{selectedItem.first_name ?? ''}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => manualLoyaltyPoints(e)} autoComplete="off">
						<div className="form-group w-100">
							<label>{t('amount')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="amount" autoFocus
								value={selectedItem.amount ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9.]/g, '') })} />
						</div>

						<div className="d-flex w-100 mt-3 gap-2">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalManualLoyaltyPoints()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL MANUAL LOYALTY POINTS */}

			{/* MODAL CHANGE PHONE */}
			<Modal show={modalChangePhone} animation={false} centered
				size="md"
				onHide={() => toggleModalChangePhone()}>
				<Modal.Header closeButton>
					<Modal.Title>{t('change_phone')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => changePhone(e)} autoComplete="off">
						<div className="form-group">
							<label>{t('current_phone')}</label>
							<input type="text" className="form-control" disabled
								value={regexPhoneNumber(selectedItem.phone1) ?? ''} />
						</div>
						<div className="form-group">
							<label>{t('new_phone')}<span className="required-mark">*</span></label>
							<input type="number" className="form-control" name="new_phone" autoFocus
								value={selectedItem.new_phone ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'new_phone': e.target.value })} />
						</div>

						<div className="d-flex w-100 mt-3 gap-2">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalChangePhone()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100"
								disabled={!selectedItem.new_phone}>
								{t('save')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL CHANGE PHONE */}

			{/* MODAL WRITE OFF */}
			<Modal show={modalWriteOffLoyaltyPoints} animation={false} centered
				size="md"
				onHide={() => toggleModalWriteOffLoyaltyPoints()}>
				<Modal.Header closeButton>
					<Modal.Title>{t('write_off')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<span className="text-danger">{t('are_you_sure_you_want_write_off_points')}</span>
					<div className="d-flex w-100 mt-3 gap-2">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={() => toggleModalWriteOffLoyaltyPoints()}>
							{t('cancel')}
						</button>
						<button type="button" className="btn btn-primary w-100"
							onClick={manualWriteOff}>
							{t('save')}
						</button>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL WRITE OFF */}

			{/* MODAL DELETE */}
			<Modal show={modalDeleteClient} animation={false} centered dialogClassName="update-modal-width"
 onHide={() => toggleDeleteModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('delete')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => deleteClient(e)} autoComplete="off">
						<h4>
							{t('delete')}?
						</h4>
						<h6 className="text-danger">
							{t('delete_text')}?
						</h6>
						<div className="d-flex gap-3 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleDeleteModal(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL DELETE */}

			{/* MODAL RESTORE */}
			<Modal show={modalRestoreClient} animation={false} centered dialogClassName="update-modal-width"
 onHide={() => toggleRestoreModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('restore')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => restoreClient(e)} autoComplete="off">
						<h5>
							{t('are_you_sure_you_want')} <b>{t('restore')}</b>
						</h5>
						<div className="d-flex gap-3 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleRestoreModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-success w-100">
								{t('confirm')}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL RESTORE */}

			<LoyaltyHistory
				showModal={loyaltyHistory.show}
				setShowModal={(boolean) => setLoyaltyHistory({ ...loyaltyHistory, 'show': boolean })}
				client={loyaltyHistory.client}>
			</LoyaltyHistory>

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>
		</>
	)
}

export default Index
